module.exports = __webpack_public_path__ + "static/media/social5.b1a5537d.svg";